import * as React from 'react';
export const walletconnectSvg = React.forwardRef(function walletconnectSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0270FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.576 12.533c2.995-2.933 7.853-2.933 10.848 0l.361.353a.37.37 0 0 1 0 .531l-1.233 1.208a.195.195 0 0 1-.272 0l-.496-.486c-2.09-2.046-5.478-2.046-7.568 0l-.531.52a.195.195 0 0 1-.272 0l-1.233-1.207a.37.37 0 0 1 0-.531l.396-.388Zm13.4 2.498 1.097 1.074a.37.37 0 0 1 0 .531l-4.95 4.847a.39.39 0 0 1-.542 0l-3.513-3.44a.097.097 0 0 0-.136 0l-3.513 3.44a.39.39 0 0 1-.542 0l-4.95-4.847a.37.37 0 0 1 0-.53l1.098-1.076a.39.39 0 0 1 .542 0l3.513 3.44a.097.097 0 0 0 .136 0l3.513-3.44a.39.39 0 0 1 .542 0l3.513 3.44a.097.097 0 0 0 .136 0l3.513-3.44a.39.39 0 0 1 .542 0Z',
      fill: '#fff',
    }),
  );
});
walletconnectSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var walletconnect = {
  category: 'brand',
  colorable: false,
  name: 'walletconnect',
  svg: walletconnectSvg,
};
